module.exports = __webpack_public_path__ + "img/heading.c537b9ff.svg";